module.exports = __webpack_public_path__ + "img/wild_0.cae502be.png";